<template>
    <div class="detailCompaniesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>
        <div v-else class="row">
            <div class="col-md-7">
                <v-form ref="form" lazy-validation class="mt-5 col-sm-8 col-md-8">

                    <v-text-field :label="'*'+$t('suppliers.label.supplier.title')" :placeholder="$t('suppliers.label.supplier.text')"
                        :counter="40" :maxlength="40" required :rules="nameSupplierRules" v-model="formData.nameSupplier" color="secondary"></v-text-field>

                    <v-select :label="'*'+$t('label.typeIdentification.title')" :placeholder="$t('label.typeIdentification.text')"
                        required :items="typeIdentification" item-text="identificationType" item-value="identificationId" 
                        :rules="typeIdentificationRules" v-model="formData.identificationId" color="secondary"></v-select>

                    <v-text-field :label="'*'+$t('label.numIdentification.title')" :placeholder="$t('label.numIdentification.text')" 
                        required :rules="identificationNumberRules" @input="formatIdentificationNumber"
                        v-model="formData.identificationNumber" @keydown="handleKeyDown" inputmode="numeric"
                        :counter="19" :maxlength="19" color="secondary"></v-text-field>

                    <v-text-field :label="'*'+$t('suppliers.label.adviser.title')" :placeholder="$t('suppliers.label.adviser.text')" 
                        :counter="100" :maxlength="100" required :rules="adviserRules" v-model="formData.adviser" color=secondary></v-text-field>

                    <v-text-field :label="'*'+$t('label.phone.title')" :placeholder="$t('label.phone.text')"
                        color="secondary" required :rules="phoneRules" v-model="formData.contactNumber"
                        @keydown="handleKeyPhoneDown" inputmode="numeric" pattern="[0-9]{0,15}" :counter="15" :maxlength="15"></v-text-field>

                    <v-text-field :label="'*'+$t('label.email.title')" :placeholder="$t('label.email.text')" 
                        color=secondary required :rules="emailRules" :counter="200" :maxlength="200" v-model="formData.email"></v-text-field>
                </v-form>

                <div class="image-container">
                    <div>
                        <changeImage :image="this.suppliers.icon" />
                    </div>
                    <div class="img-btn">

                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>{{ $t('label.image.text') }}</span>
                        </v-tooltip>

                        <input type="file" @change="onFileChange" id="file-input" accept="image/*"
                            style="display: none" />

                        <v-tooltip left>

                            <template v-slot:activator="{ attrs }">

                                <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs"
                                    @click="submitForm">
                                    <v-icon dark>mdi-content-save</v-icon>
                                </v-btn>

                            </template>

                            <span>{{ $t('button.update') }}</span>

                        </v-tooltip>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import changeImage from "@/shared/components/change_image/change_image_component.vue";

import {
    SUPPLIERS_M,
    ACTION_PUT_UPDATE_SUPPLIERS,
    GET_STATE_LOADING,
} from "@/views/suppliers/store/types/types.js";

import {
    COMPANIES_M,
    GET_COMPANIES_LIST_TYPE_DOCUMENT,
    ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT
} from "@/views/companies/store/types/types.js";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {

    components: {
        changeImage,
    },
    name: "detailCompaniesComponent",
    props: {
        suppliers: {
            required: true
        },
    },

    data() {
        return {
            formData: {
                supplierId: this.suppliers.supplierId,
                nameSupplier: this.suppliers.nameSupplier,
                adviser: this.suppliers.adviser,
                identificationId: this.suppliers.identification.identificationId,
                identificationType: this.suppliers.identification.identificationType,
                identificationNumber: this.suppliers.identificationNumber,
                contactNumber: this.suppliers.contactNumber,
                email: this.suppliers.email,
                imageFile: this.suppliers.icon,
            },

            allowedImageTypes: [
                "image/jpeg",
                "image/png",
                "image/jpg",
                "image/svg+xml",
            ],
            nameSupplierRules: [
                v => !!v || this.$t('suppliers.label.supplier.required')
            ],
            typeIdentificationRules: [
                v => !!v || this.$t('label.typeIdentification.required')
            ],
            identificationNumberRules: [
                v => !!v || this.$t('label.numIdentification.required')
            ],
            adviserRules: [
                v => !!v || this.$t('suppliers.label.adviser.required')
            ],
            phoneRules: [
                v => !!v || this.$t('label.phone.required'),
                v => (v && v.length >= 7 && v.length <= 15) || this.$t('label.phone.maxLength')
            ],
            emailRules: [
                v => !!v || this.$t('label.email.required'),
                v => emailRegex.test(v) || this.$t('label.email.invalid')
            ],

            showErrorMessages: false,
            emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
            suppliersUpdate: null,
        };
    },

    async mounted() {
        this.getActionTypeIdentification();
    },

    computed: {
        ...mapGetters({
            loading: [`${SUPPLIERS_M}${GET_STATE_LOADING}`],
            typeIdentification: [`${COMPANIES_M}${GET_COMPANIES_LIST_TYPE_DOCUMENT}`]
        }),
        imageUrl() {
            return this.formData.imageFile;
        },
    },

    methods: {

        ...mapActions({
            putActionUpdateSuppliers: `${SUPPLIERS_M}${ACTION_PUT_UPDATE_SUPPLIERS}`,
            getActionTypeIdentification: `${COMPANIES_M}${ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT}`
        }),

        handleKeyDown(event) {
            if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },

        handleKeyPhoneDown(event) {
            const allowedKeys = /^[0-9()-]$/;
            if (!allowedKeys.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },
   
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.formData.imageFile = file;
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.suppliers.icon = e.target.result;
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.imageFile.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.invalid.title'),
                    text: i18n.t('label.image.invalid')
                });
            }
        },

        async submitForm() {
            try {
                const result = await Swal.fire({
                    title: i18n.t('label.confirm.title'),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: i18n.t('button.save.text'),
                    cancelButtonText: i18n.t('button.cancel.text'),
                    confirmButtonColor: '#6E17A5'
                });

                if (result.isConfirmed) {
                    const validationErrors = this.validateForm();

                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.errorsValidation.plural.title'),
                            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }

                    const update = await this.putActionUpdateSuppliers(this.formData);
                    EventBus.$emit('reload-update-suppliers');
                    if (!update) {
                        return Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.invalid.title'),
                            text: i18n.t('label.invalid.text')
                        });
                    }
                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: i18n.t('label.delete.cancel'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            } catch (error) {
                console.error(i18n.t('label.failService'), error);
            }
        },

        formatIdentificationNumber() {
            let number = this.formData.identificationNumber.replace(/[^\d]/g, '');
            let formattedNumber = '';
            while (number.length > 0) {
                formattedNumber = number.slice(-3) + formattedNumber;
                number = number.slice(0, -3);
                if (number.length > 0) {
                    formattedNumber = '.' + formattedNumber;
                }
            }
            this.formData.identificationNumber = formattedNumber;
        },

        validateForm() {
            this.showErrorMessages = true;
            const notOnlyWhitespaceRegex = /\S/;

            const errors = {};

            if (!this.formData.nameSupplier || !this.formData.nameSupplier.trim() || this.formData.nameSupplier.length > 40) {
                errors.nameSupplier = this.$t('suppliers.label.supplier.title');
            }

            if (!this.formData.identificationId) {
                errors.identificationId = this.$t('label.typeIdentification.title');
            }

            if (!this.formData.identificationNumber || !this.formData.identificationNumber.trim() || this.formData.identificationNumber.length > 19) {
                errors.identificationNumber = this.$t('label.numIdentification.title');
            }

            if (!this.formData.adviser || !notOnlyWhitespaceRegex.test(this.formData.adviser) || this.formData.adviser.length > 100) {
                errors.adviser = this.$t('suppliers.label.adviser.title');
            }

            if (!this.formData.contactNumber || !/^[0-9]{7,15}$/.test(this.formData.contactNumber)) {
                errors.contactNumber = this.$t('label.phone.title');
            }

            if (!this.formData.email || !emailRegex.test(this.formData.email) || this.formData.email.length > 50) {
                errors.email = this.$t('label.email.title');
            }

            if (!this.formData.imageFile) {
                errors.imageFile = this.$t('suppliers.label.imageSupplier.text');
            }

            return errors;
        },
    },
};

</script>

<style lang="css" scoped>
/* Css input imagen*/

.col-md-7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 230px;
}

.row {
    display: flex;
    justify-content: center;
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* Alineación vertical */
}

.img-btn {
    margin-top: 20px;
    /* Espacio entre el componente changeImage y el botón de seleccionar imagen */
}

.user-btn {
    position: absolute;
    top: 20px;
    /* Posicionamiento en la parte superior */
    right: 20px;
    /* Posicionamiento a la derecha */
}

/*Resposive*/

@media screen and (max-width: 912px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 820px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 768px) {
    .col-md-7 {
        gap: 40px;
    }

    .image-container {
        margin-bottom: 20px;
    }
}

@media screen and (max-width: 425px) {
    .col-md-7 {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }
}


/* Para pantallas muy pequeñas */
@media screen and (max-width: 425px) {
    .col-md-7 {
        flex-direction: column;
        align-items: center;
    }

    .image-container {
        margin-bottom: 20px;
    }

    .user-btn {
        position: static;
        margin-top: 20px;
    }
}
</style>